import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App';
import reportWebVitals from './reportWebVitals'
import router from './routes'
import { RouterProvider } from "react-router-dom";
import { initRum } from './lib/rumClient';
import { initReplay } from './lib/sessionReplay';


// ---------------------------------------------------------------------------
// Session replay records what the user saw; CloudWatch RUM below keeps
// performance, errors, HTTP and traces. Started first because the recorder wraps
// fetch, XHR and console as it starts, and anything above it is a blind spot.
// ---------------------------------------------------------------------------
initReplay();

// ---------------------------------------------------------------------------
// CloudWatch RUM (AWS)
// ---------------------------------------------------------------------------
const rumAppMonitorId = process.env.REACT_APP_RUM_APP_MONITOR_ID;
const rumIdentityPoolId = process.env.REACT_APP_RUM_IDENTITY_POOL_ID;

if (rumAppMonitorId && rumIdentityPoolId) {
  initRum(
    rumAppMonitorId,
    rumIdentityPoolId,
    // The release, not a literal: it has to change per deploy or the RUM console
    // cannot tell one build from another.
    process.env.REACT_APP_APP_RELEASE ?? process.env.REACT_APP_VERSION ?? ''
  );
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
